import { render } from "./NewDataProductModal.vue?vue&type=template&id=5ea5fc72&scoped=true&ts=true"
import script from "./NewDataProductModal.vue?vue&type=script&lang=ts"
export * from "./NewDataProductModal.vue?vue&type=script&lang=ts"

import "./NewDataProductModal.vue?vue&type=style&index=0&id=5ea5fc72&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5ea5fc72"]])

export default __exports__